import React from "react";
import { Outlet } from "react-router-dom";

const TerminalServicesPage: React.FC = () => {
  return (
    <div data-testid="terminal-services-page">
      <Outlet />
    </div>
  );
};

export default TerminalServicesPage;
